import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@core/config/app.config';
import { AppComponent } from './app/app.component';
import '@core/interceptors/console-interceptor';
import 'webrtc-adapter';
import L from 'leaflet';
(window as any).L = L;

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));


/* Debug routes
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@core/config/app.config';
import { AppComponent } from './app/app.component';
import '@core/interceptors/console-interceptor';
import 'webrtc-adapter';
import { provideRouter, withDebugTracing } from '@angular/router';
import { routes } from '@app/app.routes';

bootstrapApplication(AppComponent, {
...appConfig,
providers: [
  ...(appConfig.providers || []),
  provideRouter(routes, withDebugTracing())
]
}).catch((err) => console.error(err));
*/